import {LatencyProfiler} from './LatencyProfiler';

/**
 * This class extends the LatencyProfiler class to add text-specific functionality.
 * More specifically, it only starts the profiler when the user types an alphanumeric
 * character or backspace.
 */
export class TextInputLatencyProfiler extends LatencyProfiler {
  start(event?: React.KeyboardEvent) {
    const isAltGr = event?.getModifierState?.('AltGraph') ?? false;
    if (!event || event.metaKey || (event.ctrlKey && !isAltGr)) {
      return;
    }

    // Select only keys that are alphanumeric characters, backspace, comma, period, and space.
    // This is to prevent reporting things like arrow keys, enter, etc. Because we are aiming for
    // a general idea of the latency of typing, we do no need to report every single key press.
    const isAlphanumericalOrBackspace = /^[a-zA-Z0-9!?.,\s]$|^Backspace$/.test(
      event.key
    );

    // We do not want to report keys filtered above or key pressing down.
    if (isAlphanumericalOrBackspace && !event.repeat) {
      super.start();
    }
  }
}
